import {
  type ThemeOptions,
  ThemeProvider,
  createTheme,
} from "@mui/material/styles";
import { useMemo } from "react";
import { inputsCustomizations } from "./customizations/inputs";
import { navbarCustomizations } from "./customizations/navbar";
import { colorSchemes, typography, shadows, shape } from "./themePrimitives";

interface AppThemeProps {
  children: React.ReactNode;
  /**
   * This is for the docs site. You can ignore it or remove it.
   */
  disableCustomTheme?: boolean;
  themeComponents?: ThemeOptions["components"];
}

const _theme = createTheme();

export default function AppTheme({
  children,
  disableCustomTheme,
  themeComponents,
}: AppThemeProps) {
  const theme = useMemo(() => {
    return disableCustomTheme
      ? {}
      : createTheme(_theme, {
          // For more details about CSS variables configuration, see https://mui.com/material-ui/customization/css-theme-variables/configuration/
          cssVariables: {
            colorSchemeSelector: "data-mui-color-scheme",
            cssVarPrefix: "template",
          },
          colorSchemes, // Recently added in v6 for building light & dark mode app, see https://mui.com/material-ui/customization/palette/#color-schemes
          typography,
          shadows,
          shape,
          components: {
            ...inputsCustomizations,
            ...themeComponents,
            ...navbarCustomizations,
            MuiTypography: {
              ...themeComponents?.MuiTypography,
              color: "textPrimary",
            },
          },
        });
  }, [disableCustomTheme, themeComponents]);
  if (disableCustomTheme) {
    return <>{children}</>;
  }
  return (
    <ThemeProvider theme={theme} disableTransitionOnChange>
      {children}
    </ThemeProvider>
  );
}
